export default "__VITE_ASSET__CGKf$ZS6__"